/* import __COLOCATED_TEMPLATE__ from './line.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { createColorHashForKeys } from 'embercom/lib/reporting/visualization-helpers';

export default Component.extend({
  tagName: '',
  defaultKeyColorHash: computed('keys', function () {
    return this.keys ? createColorHashForKeys(this.keys) : {};
  }),
});
